// extracted by mini-css-extract-plugin
export var width100 = "z_s d_s";
export var design3Pos = "z_tB d_X";